var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "" } },
    [
      _c(
        "v-master-detail-pane",
        {
          attrs: { selected: _vm.selectedLoad },
          on: {
            reset: function($event) {
              return _vm.selectLoad(null)
            }
          }
        },
        [
          _c(
            "template",
            { slot: "master" },
            [
              _c(
                "v-load-nav-list",
                {
                  attrs: {
                    "search-prompt": "Search " + _vm.loads.length + " loads",
                    title: "Monthly Loads",
                    "accurate-since": _vm.loadsAccurateSince,
                    loads: _vm.filteredLoads,
                    customerLoads: _vm.groupedBySponsorLoads,
                    carrierLoads: _vm.groupedByCarrierLoads,
                    loading: _vm.loading,
                    history: ""
                  },
                  on: {
                    "update:searchTerm": function($event) {
                      _vm.search = $event
                    },
                    loadMonth: function($event) {
                      return _vm.$emit("selectMonth", $event)
                    },
                    selectMonth: function($event) {
                      return _vm.$emit("selectMonth", $event)
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "loadTile",
                      fn: function(ref) {
                        var idx = ref.idx
                        var archive = ref.load
                        return [
                          _c(
                            "v-list-tile",
                            {
                              key:
                                "unassigned_load_" +
                                idx +
                                "_" +
                                archive.load.listingHumanId,
                              class: {
                                "primary lighten-1": _vm.isSelectedLoad(
                                  archive.load
                                )
                              },
                              attrs: {
                                inactive: _vm.isSelectedLoad(archive.load),
                                ripple: "",
                                avatar: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.selectLoad(archive.load)
                                }
                              }
                            },
                            [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.loadModel.loadNickname(
                                          archive.load
                                        ) ||
                                          _vm._.get(
                                            archive.load,
                                            "sponsor.name",
                                            "..."
                                          )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-sub-title",
                                    { staticClass: "text--primary" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(archive.load.humanId) +
                                          ": " +
                                          _vm._s(
                                            _vm._f("formatShortDate")(
                                              archive.delivered ||
                                                archive.archived
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-list-tile-sub-title", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.loadModel.haulingCompany(
                                            archive.load
                                          ).name
                                        ) +
                                        " "
                                    ),
                                    archive.load.tacticalInfo
                                      .assignedTruckingCompanyDriverName
                                      ? _c("span", [
                                          _vm._v(
                                            ", " +
                                              _vm._s(
                                                archive.load.tacticalInfo
                                                  .assignedTruckingCompanyDriverName
                                              )
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._.get(
                                      archive.load,
                                      "terms.customerSettlement",
                                      false
                                    )
                                      ? _c("span", [
                                          _vm._v(
                                            ", $" +
                                              _vm._s(
                                                archive.load.terms
                                                  .customerSettlement.amount
                                              )
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-action",
                                [
                                  _c(
                                    "v-chip",
                                    {
                                      attrs: {
                                        color: "primary",
                                        "text-color": "white",
                                        small: ""
                                      }
                                    },
                                    [
                                      _c("v-icon", [
                                        _vm._v(
                                          _vm._s(_vm.archiveStatusIcon(archive))
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider", {
                            key:
                              "unassigned_divider_" +
                              idx +
                              "_" +
                              archive.load.listingHumanId
                          })
                        ]
                      }
                    },
                    {
                      key: "customerLoadsTile",
                      fn: function(ref) {
                        var idx = ref.idx
                        var archives = ref.loads
                        var sponsor = ref.sponsor
                        return [
                          _c(
                            "v-list-group",
                            { key: "groupedBy_" + idx },
                            [
                              _c(
                                "v-list-tile",
                                {
                                  attrs: { slot: "activator" },
                                  slot: "activator"
                                },
                                [
                                  _c(
                                    "v-list-tile-action",
                                    [
                                      _c(
                                        "v-chip",
                                        {
                                          attrs: {
                                            color: "green",
                                            "text-color": "white",
                                            small: ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(archives.length) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-list-tile-title", [
                                    _vm._v(_vm._s(sponsor))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._l(archives, function(archive) {
                                return [
                                  _c(
                                    "v-list-tile",
                                    {
                                      key:
                                        "grouped_load_" + archive.load.humanId,
                                      class: {
                                        "primary lighten-1": _vm.isSelectedLoad(
                                          archive.load
                                        )
                                      },
                                      attrs: {
                                        inactive: _vm.isSelectedLoad(
                                          archive.load
                                        ),
                                        ripple: "",
                                        avatar: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.selectLoad(archive.load)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-list-tile-content",
                                        [
                                          _vm.loadModel.loadNickname(
                                            archive.load
                                          )
                                            ? _c("v-list-tile-title", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.loadModel.loadNickname(
                                                      archive.load
                                                    )
                                                  )
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile-sub-title",
                                            { staticClass: "text--primary" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(archive.load.humanId) +
                                                  ": " +
                                                  _vm._s(
                                                    _vm._f("formatShortDate")(
                                                      archive.delivered ||
                                                        archive.archived
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("v-list-tile-sub-title", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.loadModel.haulingCompany(
                                                    archive.load
                                                  ).name
                                                )
                                            ),
                                            archive.load.tacticalInfo
                                              .assignedTruckingCompanyDriverName
                                              ? _c("span", [
                                                  _vm._v(
                                                    ", " +
                                                      _vm._s(
                                                        archive.load
                                                          .tacticalInfo
                                                          .assignedTruckingCompanyDriverName
                                                      )
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm._.get(
                                              archive.load,
                                              "terms.customerSettlement",
                                              false
                                            )
                                              ? _c("span", [
                                                  _vm._v(
                                                    ", $" +
                                                      _vm._s(
                                                        archive.load.terms
                                                          .customerSettlement
                                                          .amount
                                                      )
                                                  )
                                                ])
                                              : _vm._e()
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-action",
                                        [
                                          _c(
                                            "v-chip",
                                            {
                                              attrs: {
                                                color: "primary",
                                                "text-color": "white",
                                                small: ""
                                              }
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.archiveStatusIcon(
                                                      archive
                                                    )
                                                  )
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-divider", {
                                    key: "load_divider_" + archive.load.humanId
                                  })
                                ]
                              })
                            ],
                            2
                          )
                        ]
                      }
                    },
                    {
                      key: "carrierLoadsTile",
                      fn: function(ref) {
                        var idx = ref.idx
                        var archives = ref.loads
                        var carrier = ref.carrier
                        return [
                          _c(
                            "v-list-group",
                            { key: "groupedBy_" + idx },
                            [
                              _c(
                                "v-list-tile",
                                {
                                  attrs: { slot: "activator" },
                                  slot: "activator"
                                },
                                [
                                  _c(
                                    "v-list-tile-action",
                                    [
                                      _c(
                                        "v-chip",
                                        {
                                          attrs: {
                                            color: "accent",
                                            "text-color": "white",
                                            small: ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(archives.length) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-list-tile-title", [
                                    _vm._v(_vm._s(carrier))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._l(archives, function(archive) {
                                return [
                                  _c(
                                    "v-list-tile",
                                    {
                                      key:
                                        "grouped_load_" + archive.load.humanId,
                                      class: {
                                        "primary lighten-1": _vm.isSelectedLoad(
                                          archive.load
                                        )
                                      },
                                      attrs: {
                                        inactive: _vm.isSelectedLoad(
                                          archive.load
                                        ),
                                        ripple: "",
                                        avatar: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.selectLoad(archive.load)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-list-tile-content",
                                        [
                                          _vm.loadModel.loadNickname(
                                            archive.load
                                          )
                                            ? _c("v-list-tile-title", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.loadModel.loadNickname(
                                                      archive.load
                                                    )
                                                  )
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile-sub-title",
                                            { staticClass: "text--primary" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(archive.load.humanId) +
                                                  ": " +
                                                  _vm._s(
                                                    _vm._f("formatShortDate")(
                                                      archive.delivered ||
                                                        archive.archived
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("v-list-tile-sub-title", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  archive.load.sponsor.name
                                                )
                                            ),
                                            archive.load.tacticalInfo
                                              .assignedTruckingCompanyDriverName
                                              ? _c("span", [
                                                  _vm._v(
                                                    ", " +
                                                      _vm._s(
                                                        archive.load
                                                          .tacticalInfo
                                                          .assignedTruckingCompanyDriverName
                                                      )
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm._.get(
                                              archive,
                                              "load.terms.customerSettlement",
                                              false
                                            )
                                              ? _c("span", [
                                                  _vm._v(
                                                    ", $" +
                                                      _vm._s(
                                                        archive.load.terms
                                                          .customerSettlement
                                                          .amount
                                                      )
                                                  )
                                                ])
                                              : _vm._e()
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-action",
                                        [
                                          _c(
                                            "v-chip",
                                            {
                                              attrs: {
                                                color: "primary",
                                                "text-color": "white",
                                                small: ""
                                              }
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.archiveStatusIcon(
                                                      archive
                                                    )
                                                  )
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-divider", {
                                    key: "load_divider_" + archive.load.humanId
                                  })
                                ]
                              })
                            ],
                            2
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c(
                    "template",
                    { slot: "subheader" },
                    [
                      _c(
                        "v-subheader",
                        {
                          staticClass: "sort-btn",
                          on: {
                            click: function($event) {
                              return _vm.toggleSort()
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "pr-2",
                              attrs: { color: "primary" }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s("play_for_work") +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v("Delivery/Cancellation")]),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            { staticClass: "pl-3", attrs: { color: "accent" } },
                            [_vm._v("\n              event\n            ")]
                          ),
                          _vm._v(" "),
                          _vm.sortDesc
                            ? _c("v-icon", { attrs: { color: "accent" } }, [
                                _vm._v(
                                  "\n              arrow_drop_down\n            "
                                )
                              ])
                            : _c("v-icon", { attrs: { color: "accent" } }, [
                                _vm._v(
                                  "\n              arrow_drop_up\n            "
                                )
                              ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "detail" },
            [
              _vm.selectedLoad
                ? _c("load-detail", {
                    attrs: {
                      currentLoad: _vm.selectedLoad,
                      company: _vm.company
                    },
                    on: {
                      refreshLoad: function($event) {
                        return _vm.refreshSelectedLoad()
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-698425b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-698425b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/simple/MonthHistoryLoads.vue
// module id = null
// module chunks = 